import {
  isAllowedPackagingVolumeCm3Input,
  isValidPackagingVolumeCm3Input,
} from '@/shared/components/packaging/componentNumericInput'
import {
  InputGroup,
  InputGroupAddon,
  InputGroupNumberInput,
  InputGroupText,
} from '@/components/ui/input-group'
import { Label } from '@/components/ui/label'

export type PackagingVolumeCm3FieldLabels = {
  label: string
  importantNoteTitle: string
  importantNoteBody: string
  invalidMessage: string
}

type PackagingVolumeCm3FieldProps = {
  id: string
  value: string
  onChange: (value: string) => void
  labels: PackagingVolumeCm3FieldLabels
  disabled?: boolean
  showImportantNote?: boolean
}

export function PackagingVolumeCm3Field({
  id,
  value,
  onChange,
  labels,
  disabled = false,
  showImportantNote = true,
}: PackagingVolumeCm3FieldProps) {
  const hasError = !isValidPackagingVolumeCm3Input(value)
  const errorId = `${id}-error`

  return (
    <div className='space-y-1'>
      <Label htmlFor={id}>{labels.label}</Label>
      {showImportantNote && (
        <div className='text-sm'>
          <p className='leading-relaxed whitespace-pre-line text-muted-foreground'>
            <span className='font-bold text-amber-500'>
              {labels.importantNoteTitle}
            </span>{' '}
            {labels.importantNoteBody}
          </p>
        </div>
      )}
      <InputGroup className='max-w-36'>
        <InputGroupNumberInput
          id={id}
          autoComplete='off'
          value={value}
          allowNegative={false}
          decimalScale={4}
          disabled={disabled}
          isAllowed={isAllowedPackagingVolumeCm3Input}
          aria-invalid={hasError}
          aria-describedby={hasError ? errorId : undefined}
          onValueChange={({ value: nextValue }) => {
            onChange(nextValue)
          }}
        />
        <InputGroupAddon align='inline-end'>
          <InputGroupText>cm³</InputGroupText>
        </InputGroupAddon>
      </InputGroup>
      {hasError && (
        <p id={errorId} className='text-sm text-destructive'>
          {labels.invalidMessage}
        </p>
      )}
    </div>
  )
}
